import { component, prop } from '../../../../decorators';

import { OPENER_MIXIN } from '../../../../mixins/opener.mixin';

import Checkbox from '../../../../components/common/checkbox/checkbox.vue';

import l10n from '../../../../transformers/l10n';

import without from 'lodash/without';
import map from 'lodash/map';
import includes from 'lodash/includes';

@component({
   mixins: [ OPENER_MIXIN ],
   components: { Checkbox },
   watch: {
      selected: 'onChangeSelected'
   }
})
export default class FlowHeadersFilter {
   @prop({ type: Array, required: true }) selected
   @prop({ type: Array, required: true }) types

   headers = []

   get title() {
      return l10n('flow.filter-title')
   }

   change(type, isChecked) {
      if ( isChecked ) {
         this.$emit('change', [ ...this.selected, type ]);
      } else {
         this.$emit('change', without(this.selected, type));
      }
   }

   onChangeSelected() {
      this.headers = map(this.types, ({type, name}) => {
         const header = { type, name };
         header.selected = includes(this.selected, type);
         return header;
      });
   }

   created() {
      this.onChangeSelected();
   }
}

